import {
	Button,
	Modal as ChakraModal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from '@chakra-ui/react';
import React from 'react';

type ModalProps = {
	initialRef: any;
	title: string;
	isOpen: boolean;
	onSubmit: ModalSaveEventHandler;
	onCancel: ModalCancelEventHandler;
	submitEnabled: boolean;
};

export type ModalSaveEventHandler = () => void;
export type ModalCancelEventHandler = () => void;

const Modal: React.FC<ModalProps> = ({
	initialRef,
	title,
	children,
	isOpen,
	onSubmit,
	onCancel,
	submitEnabled,
}) => {
	return (
		<ChakraModal
			size="5xl"
			initialFocusRef={initialRef}
			// finalFocusRef={finalRef}
			isOpen={isOpen}
			onClose={onCancel}
		>
			<ModalOverlay />
			<ModalContent m={[1, 2, 4, 12]}>
				<ModalHeader>{title}</ModalHeader>
				<ModalCloseButton />
				<ModalBody pb={4}>{children}</ModalBody>
				<ModalFooter>
					<Button
						colorScheme="blue"
						mr={3}
						onClick={onSubmit}
						disabled={!submitEnabled}
					>
						Save
					</Button>
					<Button onClick={onCancel}>Cancel</Button>
				</ModalFooter>
			</ModalContent>
		</ChakraModal>
	);
};

export default Modal;
